import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { translations, tpl } from "@/i18n/translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "gb-lang";

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved === "en" || saved === "it" ? saved : "it";
  });

  const setLang = useCallback((l) => {
    localStorage.setItem(STORAGE_KEY, l);
    setLangState(l);
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (path, vars) => {
      const lookup = (dict) => path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), dict);
      let v = lookup(translations[lang]);
      if (v === undefined) v = lookup(translations.it);
      if (v === undefined) return path;
      return typeof v === "string" ? tpl(v, vars) : v;
    },
    [lang]
  );

  const locale = lang === "en" ? "en-GB" : "it-IT";

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, locale }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
